export default __webpack_public_path__ + "static/media/CartaoBeneficio.593c168c.svg";